import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import QRCode from "qrcode";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SearchIcon from "@mui/icons-material/Search";
import { AuthLoginInfo } from "../AuthComponents/AuthLogin";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function VoucherPage() {
  const [voucherData, setVoucherData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [newVoucherSubmitted, setNewVoucherSubmitted] = useState(false);
  const [voucherDetails, setVoucherDetails] = useState({
    voucherCode: "",
    discount: 0,
    isPercent: false,
    expiredTime: "",
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterVouchers, setFilterVouchers] = useState("");

  // QR Code related states
  const [buttonQrPopup, setButtonQrPopup] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [qrCodeData, setQrCodeData] = useState(null);
  const [qrCodeImageUrl, setQrCodeImageUrl] = useState(null);
  const [guestVoucherInfo, setGuestVoucherInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalVouchers = filteredData.length;
  const computedVouchers = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const formatToCurrency = (number) => {
    return number.toLocaleString('vi-VN');
  };

  // Function to generate QR code data string
  const generateQrCodeString = (guestInfo, vouchers) => {
    if (!guestInfo || !vouchers || vouchers.length === 0) return "";
    
    // Find the voucher with the highest ID (latest voucher)
    const latestVoucher = vouchers.reduce((latest, current) => {
      return current.id > latest.id ? current : latest;
    });
    
    return latestVoucher.voucherCode;
  };

  // Function to search vouchers by phone number
  const searchVouchersByPhone = async () => {
    if (!phoneNumber.trim()) {
      alert("Vui lòng nhập số điện thoại");
      return;
    }
    let validPhoneNumber = phoneNumber.trim();
    if (validPhoneNumber.startsWith('0')) {
      // replace first '0' with country code '84'
      validPhoneNumber = validPhoneNumber.replace(/^0/, '84');
    }

    setLoading(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await axios.get(
        `${config.apiEndpoint}/Voucher/by-phone/${validPhoneNumber}`,
        { 
          headers: { Authorization: `Bearer ${token}` }, 
          withCredentials: true 
        }
      );

      if (response.status === 200) {
        setGuestVoucherInfo(response.data);
        const qrString = generateQrCodeString(response.data.guestInfo, response.data.vouchers);
        setQrCodeData(qrString);
        
        // Generate QR code image
        if (qrString) {
          try {
            const qrImageUrl = await QRCode.toDataURL(qrString, {
              width: 256,
              margin: 2,
              color: {
                dark: '#000000',
                light: '#FFFFFF'
              }
            });
            setQrCodeImageUrl(qrImageUrl);
          } catch (qrError) {
            console.error("Error generating QR code image:", qrError);
            setQrCodeImageUrl(null);
          }
        }
        
        console.log("Voucher data retrieved successfully:", response.data);
      }
    } catch (err) {
      console.error("Error fetching vouchers by phone:", err);
      alert("Không tìm thấy thông tin voucher cho số điện thoại này");
      setGuestVoucherInfo(null);
      setQrCodeData(null);
      setQrCodeImageUrl(null);
    } finally {
      setLoading(false);
    }
  };


  const addNewVoucher = () => {
    const token = localStorage.getItem('token');
    console.log('voucherDetails :', voucherDetails);
    
    const voucherPayload = {
        voucherCode: voucherDetails.voucherCode,
        discount: voucherDetails.discount,
        isPercent: voucherDetails.isPercent,
    };

    if (voucherDetails.expiredTime) {
        voucherPayload.expiredTime = voucherDetails.expiredTime;
    }

    axios
      .post(
        `${config.apiEndpoint}/Voucher`,
        voucherPayload,
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setVoucherDetails({
            voucherCode: "",
            discount: 0,
            isPercent: false,
          });
          console.log("New voucher added successfully");
          setButtonNewPopup(false);
          setNewVoucherSubmitted(!newVoucherSubmitted); // Toggle to trigger useEffect
        }
      })
      .catch((err) => {
        console.error("Error adding new voucher:", err);
        console.log(err.response);
      });
  };

  const updateVoucher = () => {
    const token = localStorage.getItem('token');
    console.log('voucherData :', voucherDetails);
 
    axios.put(
        `${config.apiEndpoint}/Voucher/${voucherDetails.id}`,
        {
            id : voucherDetails.id,
            voucherCode : voucherDetails.voucherCode,
            discount : voucherDetails.discount,
            isPercent: voucherDetails.isPercent,
            expiredTime: voucherDetails.expiredTime,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
    )
    .then((res) => {
        if (res.status === 204) {   
            setNewVoucherSubmitted(!newVoucherSubmitted); // Toggle to trigger useEffect
            setButtonShowPopup(false);
            console.log("Voucher updated successfully");
        }
    })
    .catch((err) => {
        console.error("Error updating voucher:", err);
    });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/Voucher`, { headers: { Authorization: `Bearer ${token}` }, withCredentials: true })
      .then(res => {
        console.log('voucherData', res.data);
        setVoucherData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching vouchers:", err);
      });
  }, [newVoucherSubmitted]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Voucher Manager</h1>
          <Pagination
            total={totalVouchers}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterVouchers("");
                    setFilterActive(1);
                  }}
                >
                  All vouchers
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={voucherData}
                handleSearchChange={handleSearchChange}
                dataType="voucher"
                status={filterVouchers}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonQrPopup(true);
                  setPhoneNumber("");
                  setQrCodeData(null);
                  setQrCodeImageUrl(null);
                  setGuestVoucherInfo(null);
                }}
                style={{ marginRight: "10px" }}
              >
                <QrCodeIcon />
                <span className="addOrderText">QR</span>
              </button>
              {/* <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button> */}
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>Voucher ID</th>
                  <th>Voucher Code</th>
                  <th>Discount</th>
                  <th>Is Percent</th>
                  <th>Expired Time</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedVouchers.map((voucher) => {
                    return (
                    <tr key={voucher.id}>
                      <td>
                      <font className="maincolor">#</font>
                      {voucher.id}
                      </td>
                      <td>{voucher.voucherCode}</td>
                      <td>{formatToCurrency(voucher.discount)} {voucher.isPercent?"%":"vnđ"}</td>
                      <td>{voucher.isPercent ? "Yes" : "No"}</td>
                      <td>{voucher.expiredTime === "" ? "No Limit" : voucher.expiredTime}</td>
                      <td className="maincolor">
                      <button
                        className=""
                        style={{ 
                          marginRight: "20px",
                          opacity: "0.3",
                          cursor: "not-allowed",
                          pointerEvents: "none"
                        }}
                        disabled
                      >
                        <RemoveRoundedIcon />
                      </button>
                      <button
                        className=""
                        style={{ 
                          opacity: "0.3",
                          cursor: "not-allowed",
                          pointerEvents: "none"
                        }}
                        disabled
                      >
                        <ReadMoreRoundedIcon />
                      </button>
                      </td>
                    </tr>
                    );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new Voucher</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Voucher Code"
                    className="orderDetailsInput"
                    value={voucherDetails.voucherCode}
                    onChange={(e) =>
                      setVoucherDetails({
                        ...voucherDetails,
                        voucherCode: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="number"
                    placeholder="Discount"
                    className="orderDetailsInput"
                    value={voucherDetails.discount}
                    onChange={(e) =>
                      setVoucherDetails({
                        ...voucherDetails,
                        discount: Number(e.target.value),
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <input
                    type="checkbox"
                    checked={voucherDetails.isPercent}
                    onChange={(e) =>
                      setVoucherDetails({
                        ...voucherDetails,
                        isPercent: e.target.checked,
                      })
                    }
                  />
                  <label>Is Percent</label>
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Expired Time"
                    className="orderDetailsInput"
                    value={voucherDetails.expiredTime}
                    onChange={(e) =>
                      setVoucherDetails({
                        ...voucherDetails,
                        expiredTime: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewVoucher()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
      <div className="popupWrap">
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit Voucher</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                {true && (
                  <div className="input-group">
                    <input
                        type="text"
                        placeholder="Voucher Code"
                        className="orderDetailsInput"
                        value={voucherDetails.voucherCode}
                        onChange={(e) =>
                        setVoucherDetails({
                            ...voucherDetails,
                            voucherCode: e.target.value,
                        })
                        }
                        required="required"
                    />
                </div>
                )}  

                {true && (
                  <div className="input-group">
                    <input
                        type="number"
                        placeholder="Discount"
                        className="orderDetailsInput"
                        value={voucherDetails.discount}
                        onChange={(e) =>
                        setVoucherDetails({
                            ...voucherDetails,
                            discount: Number(e.target.value),
                        })
                        }
                        required="required"
                    />
                </div>
                )} 

                {true && (
                  <div className="input-group">
                    <input
                        type="checkbox"
                        checked={voucherDetails.isPercent}
                        onChange={(e) =>
                        setVoucherDetails({
                            ...voucherDetails,
                            isPercent: e.target.checked,
                        })
                        }
                    />
                    <label>Is Percent</label>
                </div>
                )} 

                {true && (
                  <div className="input-group">
                    <input
                        type="text"
                        placeholder="Expired Time"
                        className="orderDetailsInput"
                        value={voucherDetails.expiredTime}
                        onChange={(e) =>
                        setVoucherDetails({
                            ...voucherDetails,
                            expiredTime: e.target.value,
                        })
                        }
                        required="required"
                    />
                </div>
                )} 
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => {
                    updateVoucher();
                }}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      {/* QR Code Modal */}
      <Popup trigger={buttonQrPopup} setTrigger={setButtonQrPopup}>
        <div className="popupWrap" style={{ height: "700px" }}>
          <div className="productSummary" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 className="productSummaryLeft">Get QR Code</h3>
          </div>
          
          {/* Phone Search Section */}
          <div className="addNewOrderWrap" style={{ marginBottom: "10px", height: "200px" }}>
            <div className="addNewOrderForm" >
              <div className="orderDetails" style={{ marginBottom: "0" }}>
                <div className="input-group" style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                  <input
                    type="text"
                    placeholder="Nhập số điện thoại"
                    className="orderDetailsInput"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    style={{ flex: 1, marginTop: "10px" }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        searchVouchersByPhone();
                      }
                    }}
                  />
                  <button
                    className="submitNewOrderBtn"
                    onClick={searchVouchersByPhone}
                    disabled={loading}
                    style={{ 
                      minWidth: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px"
                    }}
                  >
                    <SearchIcon />
                    <span>{loading ? "Đang tìm..." : "Search"}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Area - Two Column Layout */}
          {(qrCodeImageUrl || guestVoucherInfo) && (
            <div style={{ 
              display: "flex", 
              gap: "20px", 
              padding: "15px 20px",
              borderTop: "1px solid #eee",
              height: "calc(100% - 140px)",
              overflow: "hidden"
            }}>
              
              {/* Left Side - QR Code */}
              <div style={{ 
                width: "50%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
              }}>
                {qrCodeImageUrl && (
                  <>
                    <h4 style={{ marginBottom: "15px", color: "#333" }}>QR Code</h4>
                    <div style={{
                      padding: "20px",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      border: "2px solid #007bff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                    }}>
                      <img 
                        src={qrCodeImageUrl} 
                        alt="QR Code" 
                        style={{ 
                          width: "200px", 
                          height: "200px",
                          border: "none"
                        }} 
                      />
                    </div>
                    <p style={{ 
                      fontSize: "14px", 
                      color: "#007bff", 
                      marginTop: "15px",
                      fontWeight: "500",
                      textAlign: "center"
                    }}>
                      📱 Quét mã QR để sử dụng voucher
                    </p>
                    <p style={{ 
                      fontSize: "11px", 
                      color: "#666", 
                      marginTop: "5px",
                      fontStyle: "italic",
                      textAlign: "center",
                      wordBreak: "break-all",
                      maxWidth: "200px"
                    }}>
                      {qrCodeData}
                    </p>
                  </>
                )}
              </div>

              {/* Right Side - Customer Info and Vouchers */}
              <div style={{ 
                width: "50%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
              }}>
                {guestVoucherInfo && (
                  <>
                    <h4 style={{ marginBottom: "15px", color: "#333" }}>Thông tin khách hàng</h4>
                    <div style={{ 
                      backgroundColor: "#f8f9fa", 
                      padding: "15px", 
                      borderRadius: "8px",
                      marginBottom: "15px",
                      fontSize: "14px"
                    }}>
                      <p style={{ margin: "5px 0" }}><strong>Tên:</strong> {guestVoucherInfo.guestInfo.name}</p>
                      <p style={{ margin: "5px 0" }}><strong>SĐT:</strong> {guestVoucherInfo.guestInfo.phoneNumber}</p>
                      <p style={{ margin: "5px 0" }}><strong>Điểm:</strong> {formatToCurrency(guestVoucherInfo.guestInfo.point)} điểm</p>
                    </div>

                    <h5 style={{ marginBottom: "10px", color: "#333" }}>
                      Danh sách Voucher ({guestVoucherInfo.vouchers.length})
                    </h5>
                    <div style={{ 
                      flex: 1,
                      overflow: "auto",
                      paddingRight: "5px"
                    }}>
                      {guestVoucherInfo.vouchers.length > 0 ? (
                        guestVoucherInfo.vouchers.map((voucher, index) => (
                          <div key={voucher.id} style={{
                            padding: "12px",
                            backgroundColor: voucher.isExpired ? "#ffebee" : "#e8f5e8",
                            border: "1px solid " + (voucher.isExpired ? "#ffcdd2" : "#c8e6c9"),
                            borderRadius: "6px",
                            marginBottom: "10px",
                            fontSize: "13px"
                          }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                              <span><strong>Giảm:</strong> {voucher.discountText}</span>
                              <span style={{ 
                                color: voucher.isExpired ? "#d32f2f" : "#2e7d32",
                                fontWeight: "bold",
                                fontSize: "11px",
                                padding: "2px 6px",
                                borderRadius: "4px",
                                backgroundColor: voucher.isExpired ? "#ffcdd2" : "#c8e6c9"
                              }}>
                                {voucher.isExpired ? "HẾT HẠN" : "CÒN HẠN"}
                              </span>
                            </div>
                            <div style={{ fontSize: "11px", color: "#666" }}>
                              <div style={{ marginBottom: "3px" }}>Mã: {voucher.voucherCode.substring(0, 12)}...</div>
                              <div>Hết hạn: {new Date(voucher.expiredTime).toLocaleDateString('vi-VN')}</div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p style={{ textAlign: "center", color: "#666", fontStyle: "italic", padding: "20px" }}>
                          Không có voucher nào
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {!qrCodeImageUrl && !loading && (
            <div style={{ 
              padding: "40px", 
              textAlign: "center", 
              color: "#666",
              fontStyle: "italic"
            }}>
              <QrCodeIcon style={{ fontSize: "48px", opacity: 0.3, marginBottom: "10px" }} />
              <p>Nhập số điện thoại và nhấn Search để tạo QR code</p>
            </div>
          )}
        </div>
      </Popup>
    </div>
  );
}

export default VoucherPage;